import useCurrentTeam from 'core/hooks/team/useCurrentTeam'

const useIsFboWallet = () => {
  const { data } = useCurrentTeam()
  return data?.payment_process_type === 'invoice'
}

export default useIsFboWallet
